<template>
    <div>
        <div class="spacer"></div>
        <div class="col-md-8 col-sm-12 container">
            <div class="d-flex align-items-top">
                <RouterLink :to="{name: 'Dashboard'}" class="fa-2x fas text-info text-decoration-none fa-arrow-alt-circle-left mr-2"></RouterLink>
                <h1 class="h3">{{title}}</h1>
            </div>
            <form @submit.prevent="submitForm" class="lead mt-4">
                <div class="form-group" v-if="disableTitle != false">
                    <label>Titulo</label>
                    <br>
                    <input type="text" class="form-control" v-model="form.title" placeholder="Ingresá el título" required> 
                </div>         

                <div class="form-group mt-4" v-if="disableImage != false"> 
                    <label>Imagen principal</label>             
                    <div class="image-preview" :style="{'background-image' : `url(${imagePreview})`}"></div>
                    <input type="file" accept="image/png, image/jpeg" ref="inputImage" @change="selectImage" class="form-control-file mt-3" :required="!this.form.thumbnail"> 
                </div>

                <div class="form-group mt-5" v-if="loaderPdf"> 
                    <h3 class="h5 font-weight-bold">Cargar PDF</h3>     
                    <select class="custom-select" v-model="optionPdfSelected" @change="doDeletePdf">
                        <option value="file">Archivo</option>
                        <option value="url" >Url</option>
                        <option value="consult" selected>Consultar en biblioteca</option>
                    </select>
                    <div class="mt-3">
                        <!-- File -->
                        <div v-if="optionPdfSelected == 'file'">
                            <input type="file" accept="file" ref="inputPdf" @change="selectPdf" class="form-control-file" required> 
                            
                            <div class="progress mt-2" v-show="$store.state.utils.isUploading">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{'width': `${$store.state.utils.uploadStatus}%`}"></div>
                            </div>
                            <div v-if="linkToPdf">

                                <a :href="linkToPdf" target="_blank"  type="button" class="btn btn-lg btn-primary mr-2 mt-2">Ver PDF
                                    <i class="fa-file-download fa-lg fas ml-1"></i>
                                </a>

                                <button type="button" @click="doDeletePdf" class="btn btn-danger btn-sm mt-2">Eliminar PDF
                                    <i class="fa-trash fas"></i>
                                </button>

                            </div>
                        </div>


                        <!-- URL -->
                        <div v-if="optionPdfSelected == 'url'">
                            <label for="">Ingresa la url del pdf</label>
                            <input type="text" class="form-control" v-model="selectedPdf" id="check-library" placeholder="Ingrese la url del pdf" required>

                            <div v-if="selectedPdf">
                                <a :href="selectedPdf" target="_blank"  type="button" class="btn btn-lg btn-primary mr-2 mt-2">Ver PDF
                                    <i class="fa-file-download fa-lg fas ml-1"></i>
                                </a>

                                <button type="button" @click="selectedPdf = ''" class="btn btn-danger btn-sm mt-2">Eliminar PDF
                                    <i class="fa-trash fas"></i>
                                </button>
                            </div>
                        </div>
                        
                    </div>
                </div>


                <div class="form-group mt-4" v-if="categories"> 
                    <label>Categorías</label>             
                    <div class="pb-1 small custom-control custom-checkbox" v-for="(category, index) in categories" :key="index"> 
                        <input type="checkbox" class="custom-control-input" :value="category" v-model="form.categories" :id="category"> 
                        <label class="custom-control-label pointer" :class="{'text-primary': form.categories.includes(category)}" :for="category">{{category}}</label>                     
                    </div>
                </div>

                <div class="form-group mt-4" v-if="tags"> 
                    <label>Etiquetas</label>             
                    <div class="pb-1 small custom-control custom-checkbox" v-for="(tag, index) in tags" :key="index"> 
                        <input type="checkbox" class="custom-control-input" :value="tag" v-model="form.tags" :id="tag"> 
                        <label class="custom-control-label pointer" :class="{'text-primary': form.tags.includes(tag)}" :for="tag">{{tag}}</label>                     
                    </div>
                </div>

                <div class="form-group mt-4"> 
                    <label>Descripción</label>             
                    <quill-editor v-show="showQuill" :options="editorOption" class="editor" v-model="form.description " />
                </div>

                <button type="submit" @click="submit = true" class="btn btn-primary mt-5">{{buttonText}}</button>
            </form>

            <div class="spacer-large"></div>
        </div>

    </div>
</template>

<style scoped>
.form-group{
    padding-bottom: 25px;
}
</style>

<script>
export default {
    props:{
        form:{
            type: Object,
            required: true
        },
        title:{
            type: String,
            required: true
        },
        buttonText:{
            type: String,
            required: true
        },
        categories:{
            type: Array,
            required: false
        },
        tags:{
            type: Array,
            required: false
        },
        loaderPdf:{
            type: Boolean,
            default: false
        },
        disableTitle:{},
        disableImage:{}
    },
    mounted(){
        setTimeout(()=>{
            this.showQuill = true
        }, 200)
    },
    created(){
        if(this.form.pdf.length){
            this.selectedPdf = this.form.pdf
            if(this.pdfLoadInFirebase){
                this.optionPdfSelected = 'file'
            }else{
                this.optionPdfSelected = 'url'
            }
        }
    },
    data(){
        return {
            editorOption: {
                placeholder: "",
                modules: {
                    toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'header': [1, 2, false] }],
                    [{ 'color': [] }],
                    [{ 'align': [] }],
                    ['link', 'video'],
                    ],
                }
            },
            selectedImage: null,
            selectedPdf: null,
            optionPdfSelected: 'consult',
            showQuill: false,
            submit: false
        }
    },
    computed:{
        imagePreview(){
            if(this.form.thumbnail != true && this.form.thumbnail){
                return this.form.thumbnail
            }else{
                return this.selectedImage ? URL.createObjectURL(this.selectedImage) : require('@/assets/img/utils/placeholder.jpg')
            }
        },
        pdfLoadInFirebase(){
            if(this.form.pdf){
                return this.form.pdf.includes('firebasestorage.googleapis.com')
            }
            return false
        }
    },
    methods:{
        submitForm(){
            this.$emit('submit', this.selectedImage, this.selectedPdf)
        },
        selectImage(event){
            const file = event.target.files[0]
            if(file){
                if(file.type == 'image/png' || file.type == 'image/jpeg'){
                    this.selectedImage = file
                    this.form.thumbnail = true
                }else{
                    this.$toast.error('El tipo de archivo seleccionado no es válido')
                    this.$refs.inputImage.value = null
                }
            }
        },
        async selectPdf(event){
            const file = event.target.files[0]
            if(file.type == 'application/pdf'){
                this.selectedPdf = await this.$store.dispatch('utils/uploadPdfAndGetUrl', {directory: `books/pdf/${file.name}-${Date.now()}`, pdf: file})
                this.form.pdf = null
            }else{
                this.$toast.error('El tipo de archivo seleccionado no es válido')
                this.$refs.inputPdf.value = null
            }
        },
        async doDeletePdf(){
            if(this.pdfLoadInFirebase){
                this.$store.dispatch('utils/deleteFileFromUrl', this.form.pdf)
            }
            this.selectedPdf = '' 
            this.form.pdf = this.$refs.inputPdf.value = ''
        }
    }
}
</script>